<template>
  <v-app>
    <v-main class="mn">
      <v-progress-linear :active="isLoading" indeterminate absolute top color="deep-purple accent-4"></v-progress-linear>
      <img class="logo" src="@/assets/clinam.png" />
      <slot />
    </v-main>
    <SnackBar />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
//import Header from "@/components/_layout/header";
//import Footer from "@/components/_layout/footer";
import SnackBar from "@/components/_system/snackbar.vue";

export default {
  data: () => ({}),

  components: {
    //Header, //Footer,
    SnackBar,
  },

  created() {},

  beforeDestroy() {},

  computed: {
    ...mapGetters(["user", "isLoading"]),
  },

  methods: {},
};
</script>

<style lang="scss">
.mn {
  background-color: #ffffff;
  background-position: 0 0;
}
.logo {
  position: absolute;
  top: 12px;
  left: 12px;
  height: 70px;
}

@media print {
  .v-content {
    padding-left: 0 !important;
  }
}
</style>
